export default __webpack_public_path__ + "static/image1-ee0dad580ba46011257ef4af209abc7c.png";